var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-spacer'),_c('v-dialog',{attrs:{"value":_vm.value,"retain-focus":false,"width":"800","max-width":"800"},on:{"input":_vm.bind},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mb-2",attrs:{"color":"primary","dark":""}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.add)+" ")])]}}])},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }